module.exports = __webpack_public_path__ + "img/happy_clients_bw@2x.8098031.webp";